import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./extensions/baseQueries/baseQuery";
import { baseQueryWithZodValidation } from "./extensions/baseQueries/baseQueryWithZodValidation";
import { baseQueryWithTransactionIdPopulation } from "./extensions/baseQueries/baseQueryWithTransactionIdPopulation";
import { staggeredRetryBaseQuery } from "./extensions/baseQueries/staggeredRetryBaseQuery";
import { baseQueryWithRefreshToken } from "./extensions/baseQueries/baseQueryWithRefreshToken";
import { Mutex } from "async-mutex";

const mutex = new Mutex();
// baseQueryWithTransactionIdPopulation should be before retry because transactionId must be the same at retrying process
const baseQueryWithZodValidationAndRetry = baseQueryWithRefreshToken(
  baseQueryWithZodValidation(baseQueryWithTransactionIdPopulation(staggeredRetryBaseQuery(baseQuery, 6))),
  mutex
);

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: baseQueryWithZodValidationAndRetry,
  tagTypes: ["Properties", "LegalConsents", "Loans"],
  endpoints: () => ({}),
});
